import {Stack, Typography} from '@mui/material';
import React from 'react';
import {ServiceCategory} from '../ServiceCategory';
import {NotredameOtherServicesProps} from './types';
import {useNotredameServicesList} from 'presentation/pages/private/hooks/useNotredameServicesList';
import {translations} from 'presentation/translations-new';

const {availableServices} = translations['pt-br'].privateFlow.services;

export function NotredameOtherServices({query}: NotredameOtherServicesProps) {
	const {
		healthAppointmentsServices,
		notredameHealthAppointmentsServices,
		telehealthServices,
		financialAndDocsServices,
		perksServices,
		portabilityAndPermanenceServices,
		supportServices,
		managementServices,
	} = useNotredameServicesList(query);

	return (
		<Stack gap={1}>
			<Typography variant="subtitle1" color="text.secondary" fontWeight={700}>
				{availableServices}
			</Typography>

			<Stack gap={2} component={Stack}>
				<Stack gap={1.5}>
					<ServiceCategory serviceCategory={healthAppointmentsServices} />
					<ServiceCategory serviceCategory={notredameHealthAppointmentsServices} />
					<ServiceCategory serviceCategory={telehealthServices} />
					<ServiceCategory serviceCategory={financialAndDocsServices} />
					<ServiceCategory serviceCategory={managementServices} />
					<ServiceCategory serviceCategory={portabilityAndPermanenceServices} />
					<ServiceCategory serviceCategory={perksServices} />
					<ServiceCategory serviceCategory={supportServices} />
				</Stack>
			</Stack>
		</Stack>
	);
}
